import axios from 'axios/index';
import React, {Component} from 'react';
import Form from '../../common/Form'
import SmsModal from '../../modals/SmsModal';
import ViberModal from '../../modals/ViberModal';
import Header from '../Header'
import toastr from 'toastr';
import http from '../../../services/httpService';
import FbMessengerChannel from '../distributionChannels/FbMessengerChannel';
import WebPushChannel from '../distributionChannels/WebPushChannel';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import $ from 'jquery';
import { getCurrentUserId, getJwt } from '../../../services/authService';
// import ReactGA from "react-ga";

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class DistributionPlatforms extends Form {
    constructor(props){
        super(props);
        this.state = {
            user: {
                facebook_pages_shared: props.facebook_pages_shared || [],
                facebook_pages:
                    {
                        data: props.facebook_pages || []
                    },
                missing_allowed_pages: []
            },
            clicked_fb: false,
            clicked_wp: false,
            fbPagesManagementPermission: false,
            fb_spinner: false,
            wp_spinner: false,
            spinnerActive: false,
            viberCheck: ''
        }
    }

    handleFeedMenu = () => {
        $('.feed-dropdown').fadeToggle();
    };

    componentDidMount() {
        let {user: userData, facebook_pages, facebook_pages_shared} = this.props;
       // ReactGA.pageview(window.location.pathname + window.location.search);
        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };
        this.setState({
            user
        })
        if( user.user_fb_id && user.user_fb_extended_token ){
            this.checkAdsManagementPermission(this.props.user.user_fb_id, this.props.user.user_fb_extended_token)
        }
        let viberEnableRequestsData = localStorage.getItem("viberEnableRequests");
        let smsEnableRequestsData = localStorage.getItem("smsEnableRequests");
        let dataParsed = JSON.parse(viberEnableRequestsData)
        let viberCheck = dataParsed ? dataParsed.find(source=>source === this.props.selectedSource) : '';
        if ((!this.state.check && viberCheck) || (this.state.check !== viberCheck)){
            this.setState({
                viberCheck
            })
        }
        if ( smsEnableRequestsData ){
            let smsDataParsed = JSON.parse(smsEnableRequestsData)
            let smsCheck = smsDataParsed ? smsDataParsed.find(source=>source === this.props.selectedSource) : '';
            // console.log(smsDataParsed, smsCheck)
            if ((!this.state.check && smsCheck) || (this.state.check !== smsCheck)){
                this.setState({
                    smsCheck
                })
            }
        }
    }

    componentDidUpdate(){
        let {user: userData, facebook_pages, facebook_pages_shared} = this.props;

        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };
        if ( this.state.user.id !== user.id ){
            this.setState({
                user
            })
        }

        if( user.user_fb_id && user.user_fb_extended_token ){
            this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token)
        }
    }

    toggleWP = async (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Dist platform - Enabled Webpush',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        // console.log("PlatformsSupported toggleWP this.state.clicked_wp",this.state.clicked_wp);
        this.setState({clicked_wp: !this.state.clicked_wp, wp_spinner: true});
        await this.props.enablePlatform(e);
        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 1}, {headers: {authorization: getJwt()}});
            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: true, selected_source_rss: result.data.rss})
        } else if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }
        this.setState({ wp_spinner: false })
    };

    toggleFB = async (e) => {
        //console.log("PlatformsSupported toggleFB this.state.clicked_fb",this.state.clicked_fb);
        await this.setState({clicked_fb: !this.state.clicked_fb});
        await this.props.enablePlatform(e);
        //this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        if (typeof (this.props.appPropagateUserPlatforms) !== 'undefined') {
            this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        }
        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }

    };

    checkAdsManagementPermission = async (user_fb_id, user_fb_extended_token, permissionsChangeMade) =>{
        if ( (!this.state.fbPagesManagementPermission || permissionsChangeMade) && user_fb_id && user_fb_extended_token ){
            try{
                const fbUserPermissions = await axios.get(facebook_app_graph_url + user_fb_id + '/permissions?access_token=' + user_fb_extended_token);
                const fbPagesManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'pages_messaging');
                if ( this.state.fbPagesManagementPermission !== ((fbPagesManagementPermission.status === 'granted') ? true : false )) {
                    await this.setState({
                        fbPagesManagementPermission: (fbPagesManagementPermission.status === 'granted') ? true : false
                    })
                }
            }catch (ex) {
                if (ex.response && ex.response.status === 404)
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                if (ex.response && ex.response.status === 401) {
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                }
            }
        }
    }

    permissionsChangeMade = () =>{
        let {user: userData, facebook_pages, facebook_pages_shared} = this.props;

        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };
        if ( this.state.user.id !== user.id ){
            this.setState({
                user
            })
        }

        if( user.user_fb_id && user.user_fb_extended_token ){
            this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token, true)
        }
    }

    responseFacebookForSourceEnable = async (response) => {
        try {
            this.setState({
                fb_spinner: true
            });
            if (response.status !== 'unknown' || (typeof (response.status) !== 'undefined')) {
                if (response.name !== "" && (typeof (response.name) !== 'undefined')) {
                    let source = "";
                    let sources = this.props.sources;
                    let selectedSource = this.props.selectedSource;
                   // let feeds_shared = this.props.feeds_shared;
                    if (sources) {
                        source = sources.filter(source =>
                            source.id.toString() === selectedSource.toString())[0];
                    }
                    // if (!source && feeds_shared) {
                    //     source = feeds_shared.filter(source =>
                    //         source.id.toString() === selectedSource.toString())[0];
                    // }
                    let feed_id = source.id;
                    if (feed_id === "page_source") {
                        feed_id = ""
                    }
                    let login_facebook_response = {};
                    //console.log("responseFacebook response ", response, feed_id);
                    if (response.email && response.email !== "") {
                        login_facebook_response = await http.post('api/login_facebook/' + feed_id, response, {headers: {authorization: getJwt()}});
                        await this.props.enablePlatform({
                            target: {
                                id: "fb_enable",
                                title: source.id.toString()
                            }
                        });
                        this.setState({clicked_fb: true});


                        // Update user
                        const data = login_facebook_response.data ? login_facebook_response.data.data : "";
                        const missing_allowed_pages = login_facebook_response.data.missing_allowed_pages.filter(page => page.connected )
                        if (data) {
                            this.setState({
                                user: Object.assign(
                                    {},
                                    this.state.user,
                                    {
                                        facebook_pages: data.facebook_pages,
                                        facebook_pages_shared: data.facebook_pages_shared,
                                        missing_allowed_pages
                                    }
                                )
                            });
                            await this.props.updateUser({
                                facebook_pages: data.facebook_pages,
                                facebook_pages_shared: data.facebook_pages_shared,
                                missing_allowed_pages
                            })
                        }
                        /* Updating platforms_enabled */
                        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {

                            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 1}, {headers: {authorization: getJwt()}});
                            let platformsEnabled = await result.data.platforms_enabled

                            this.props.updateSources(result.data);
                            this.props.selectSource({
                                id: result.data.id,
                                source_active: true,
                                selected_source_rss: result.data.rss
                            })
                        }

                        this.checkAdsManagementPermission(data.user_fb_id, data.user_fb_extended_token)
                    } else {
                        toastr.error("Error Code #23052: Email obtain permission has to be checked in order to register!")
                    }
                }
                this.setState({
                    fb_spinner: false
                });
            } else {
                toastr.error("Error Code #23053: Facebook response undefined! Please try later, or,  try standard register approach instead.")
            }
        } catch (ex) {
            this.setState({
                fb_spinner: false
            });
        }


    };

    doSubmit = async () => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Distribution Platforms - Next',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        let { selectedSource, platforms_enabled } = this.props;
        // let platforms_enabled = this.state.feedData.platforms_enabled;

        if (selectedSource && platforms_enabled && platforms_enabled.length > 0) {
            try {
                this.setState({spinnerActive: true});
                const result = await http.patch('api/feed/' + selectedSource, {active: 1}, {headers: {authorization: getJwt()}});
                await this.props.updateSources(result.data);
                this.props.selectSource({id: result.data.id, source_active: true, selected_source_rss: result.data.rss})
                toastr.success('New workspace \'' + result.data.name + '\' is successfully created');
                this.props.history.push(localStorage.navigateBackTo ? localStorage.navigateBackTo : 'settings')
                localStorage.removeItem('selectedTeam');
                localStorage.removeItem('navigateBackTo');
            } catch (ex) {
                this.setState({spinnerActive: false});
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
                if (ex.response && ex.response.status === 401) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    errors.email = ex.response.data.message;
                    this.setState({errors});
                }
                // this.props.history.push('dashboard')
            }
        } else {
            this.setState({spinnerActive: true});
            const newFeed = await http.get('api/feed/' + selectedSource, {headers: {authorization: getJwt()}});
            await this.props.updateSources(newFeed.data.data);
            this.props.selectSource({id: newFeed.data.data.id, source_active: false, selected_source_rss: newFeed.data.data.rss});
            this.props.appPropagateUserPlatforms(platforms_enabled)
            toastr.success('New workspace \'' + newFeed.data.data.name + '\' is successfully created');
            this.props.history.push(localStorage.navigateBackTo ? localStorage.navigateBackTo : 'settings')
            localStorage.removeItem('selectedTeam');
            localStorage.removeItem('navigateBackTo');
        }

    };

    viberModalOpen = () => {
        this.setState({
            overlayIsOpen: true
        })
    }

    viberModalClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    setViberCheck = (data) =>{
        this.setState({
            viberCheck: data
        })
    }

    smsModalOpen = () => {
        this.setState({
            smsOverlayIsOpen: true
        })
    }

    smsModalClose = () => {
        this.setState({
            smsOverlayIsOpen: false
        })
    }

    setSmsCheck = (data) =>{
        this.setState({
            smsCheck: data
        })
    }

    render() {
        const {
            sources, activateFeed,
            //feeds_shared,
            selectedSource, onClick, openModal, toggleFeedInfo, editing, rss_valid, updateUser,
            user_facebook_pages, addSource, deleteFeed, enablePlatform,
            updateSources, selectSource, teams
        } = this.props;
        let {user: userData, sourceId, facebook_pages, platforms_enabled, facebook_pages_shared, user_fb_id,
            user_fb_extended_token } = this.props;
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        $('.bkg-img').css('position', 'absolute');
        //let source, onlypage = "";
        let source = "";
        if (sources) {
            source = sources.filter(source =>
                source.id.toString() === selectedSource.toString())[0];
        }
        // if (!source && feeds_shared) {
        //     source = feeds_shared.filter(source =>
        //         source.id.toString() === selectedSource.toString())[0];
        // }
        return <div className='onboarding-container'>
            {/* console.log('Give me data: ', sources, feeds_shared, platforms_enabled, source) */}
            <Header linkDisabled={true}/>
            <div className="onboarding-content" style={{ alignItems: 'flex-start'}}>
                <div className="distribution-channels-new-project-container">
                    <h1 className='main-title'>Distribution Channels</h1>
                    <div className="supported-channels-container">
                        <h2>Supported Channels</h2>
                        <div className="channel-selector-container">
                            <div className="single-channel-container">
                                <i className="fab fa-facebook-messenger"></i>
                                <h3>FB MESSENGER</h3>
                                <p>Send paid promotional messages to your FB Messenger subscribers.</p>
                                { facebook_platform_enabled && this.state.fbPagesManagementPermission ?
                                    <p className="enabled-button" id="fb_disable" title={selectedSource}>
                                        <i className="fas fa-check"/>Enabled
                                    </p>
                                    :
                                    this.state.fb_spinner ?
                                        <div className="enable-button-spinner">
                                            <p title={selectedSource}>Enable <i className='fa fa-spin fa-spinner'/></p>
                                        </div>
                                        :
                                        <FacebookLogin
                                            appId={facebook_app_id}
                                            autoLoad={false}
                                            return_scopes={true}
                                            fields="name, email, picture"
                                            scope="email, public_profile, pages_messaging, pages_read_engagement"
                                            callback={this.responseFacebookForSourceEnable}
                                            render={renderProps => (
                                                <div onClick={renderProps.onClick} className="enable-button">
                                                    <p>Enable</p>
                                                </div>
                                            )}
                                        />
                                }
                            </div>
                            <div className="single-channel-container">
                                <i style={{color: '#665cac'}} className="fab fa-viber"></i>
                                <h3>VIBER</h3>
                                <p>Send targeted Viber messages to phone number contacts.</p>
                                { this.state.viberCheck ?
                                    <p className="enabled-button">
                                        <i className="fas fa-check"/>Requested
                                    </p>
                                    :
                                    <div className="enable-button" id="wp_enable" onClick={ this.viberModalOpen }>
                                        <p title={ selectedSource } id="wp_enable">Enable</p>
                                    </div>
                                }
                                <ViberModal
                                    showModal={this.state.overlayIsOpen}
                                    handleClose={this.viberModalClose}
                                    selectedSource={selectedSource}
                                    sources={this.props.sources}
                                    //feedsShared={feeds_shared}
                                    setViberCheck={this.setViberCheck}
                                    maxWidth={500}
                                />
                            </div>
                            <div className="single-channel-container">
                                <i className="fas fa-globe"></i>
                                <h3>WEBPUSH</h3>
                                <p>Send targeted Web Push notifications to users web browser.</p>
                                { webpush_platform_enabled ?
                                    <p className="enabled-button" id="wp_disable" title={selectedSource} onClick={this.toggleWP}>
                                        <i className="fas fa-check"/>Enabled
                                    </p>
                                    :
                                    this.state.wp_spinner ?
                                        <div className="enable-button-spinner">
                                            <p title={selectedSource}>Enable <i className='fa fa-spin fa-spinner'/></p>
                                        </div>
                                        :
                                        <div className="enable-button" id="wp_enable" onClick={this.toggleWP}>
                                            <p title={selectedSource} id="wp_enable">Enable</p>
                                        </div>
                                }
                            </div>
                            <div className="single-channel-container">
                                <i className='far fa-comment-dots'></i>
                                <h3>SMS</h3>
                                <p>Send targeted Sms messages to phone number contacts.</p>
                                { this.state.smsCheck ?
                                    <p className="enabled-button">
                                        <i className="fas fa-check"/>Requested
                                    </p>
                                    :
                                    <div className="enable-button" id="wp_enable" onClick={ this.smsModalOpen }>
                                        <p title={ selectedSource } id="wp_enable">Enable</p>
                                    </div>
                                }
                                <SmsModal
                                    showModal={this.state.smsOverlayIsOpen}
                                    handleClose={this.smsModalClose}
                                    selectedSource={selectedSource}
                                    sources={this.props.sources}
                                    //feedsShared={feeds_shared}
                                    setSmsCheck={this.setSmsCheck}
                                    maxWidth={500}
                                />
                            </div>
                            {/*
                             <div className="single-channel-container">
                             <i className="fab fa-whatsapp"></i>
                             <h3>WHATSAPP</h3>
                             <p>Send rich-text Messages to your audience across multiple platforms.</p>
                             </div>
                             <div className="single-channel-container">
                             {/*Font awesome icon for sms is not showing */}
                            {/*<i className="far fa-sms"></i>
                             <h3>SMS</h3>
                             <p>Send rich-text Messages to your audience across multiple platforms.</p>
                             </div>
                             */}
                        </div>
                    </div>
                    { facebook_platform_enabled && webpush_platform_enabled && this.state.fbPagesManagementPermission ?
                        <h2>Enabled Channels</h2>
                        :
                        <div/>
                    }
                    <div className="enabled-channels-container">
                        {(sources.length
                        //    || feeds_shared.length
                        ) && facebook_platform_enabled && this.state.fbPagesManagementPermission ?
                            <FbMessengerChannel
                                user={ this.state.user }
                                count_pages={this.props.count_pages}
                                sourceId={source.id}
                                source_rss={source.rss}
                                platforms_enabled={platforms_enabled}
                                onClick={onClick}
                                activateFeed={activateFeed}
                                facebook_pages={user_facebook_pages}
                                facebook_pages_shared={facebook_pages_shared}
                                openModal={openModal}
                                onlypage={source.onlypage}
                                web_push_id={source.web_push_id}
                                appPropagateUserData={this.props.appPropagateUserData}
                                website={source.website}
                                enablePlatform={enablePlatform}
                                updateUser={ updateUser }
                                updateSources={ updateSources }
                                selectSource={ selectSource }
                                feedActiveUpdateOnChange={ true }
                                permissionsChangeMade={ this.permissionsChangeMade }
                            />
                            :
                            <div/>
                        }
                        {(sources.length
                        //    || feeds_shared.length
                        ) && webpush_platform_enabled ?
                            <WebPushChannel
                                user={ this.props.user }
                                count_pages={this.props.count_pages}
                                sourceId={source.id}
                                source_rss={source.rss}
                                platforms_enabled={platforms_enabled}
                                onClick={onClick}
                                activateFeed={activateFeed}
                                facebook_pages={user_facebook_pages}
                                facebook_pages_shared={facebook_pages_shared}
                                openModal={openModal}
                                onlypage={source.onlypage}
                                web_push_id={source.web_push_id}
                                appPropagateUserData={this.props.appPropagateUserData}
                                website={source.website}
                                enablePlatform={enablePlatform}
                                updateUser={ updateUser }
                                updateSources={ updateSources }
                                selectSource={ selectSource }
                                feedActiveUpdateOnChange={ true }
                            />
                            :
                            <div/>
                        }
                    </div>

                    {   platforms_enabled && platforms_enabled.length > 0 ?
                            this.state.spinnerActive  === true ?
                                <button disabled onClick={this.doSubmit} className="next-button">
                                    Next <i className='fa fa-spin fa-spinner'></i>
                                </button>
                                :
                                <button onClick={this.doSubmit} className="next-button">
                                    Next
                                </button>
                            :
                            <p onClick={this.doSubmit} style={{color: '#049FF6', textAlign: 'center', marginTop: 50, cursor: 'pointer'}}>Skip for now</p>

                    }
                </div>
            </div>
        </div>
    }
}


export default DistributionPlatforms;